import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { PRACTICE_AREAS } from '../data/practiceAreas';
import { PRACTICE_AREAS_VI } from '../data/practiceAreasVi';

export function usePracticeArea(slug) {
  const { i18n } = useTranslation();
  return useMemo(() => {
    const areas = i18n.language?.startsWith('vi') ? PRACTICE_AREAS_VI : PRACTICE_AREAS;
    return areas[slug];
  }, [i18n.language, slug]);
}
